import { render } from "./KakaoChannelPb.vue?vue&type=template&id=82cd1e64"
import script from "./KakaoChannelPb.vue?vue&type=script&lang=js"
export * from "./KakaoChannelPb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__